import { ProtectedJsonAPI } from '.'

export const ReportIntervals = ProtectedJsonAPI.extend(
  '/oadr/datapoints',
  {
    index:    endpoint => endpoint.path(({rid}) => `${rid}/report_intervals`)
  }
)